import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CompanyActiveSystem {
  id: string;
  name: string;
  code: string;
  plan_name: string;
}

export const useCompanyActiveSystems = (companyId?: string) => {
  return useQuery({
    queryKey: ['company-active-systems', companyId],
    queryFn: async (): Promise<CompanyActiveSystem[]> => {
      if (!companyId) return [];

      const { data, error } = await supabase
        .from('company_system_plans')
        .select(`
          system_id,
          plans!inner(
            name,
            systems!inner(
              id,
              name,
              code,
              is_active
            )
          )
        `)
        .eq('company_id', companyId)
        .eq('status', 'active')
        .eq('plans.systems.is_active', true);

      if (error) throw error;

      return data.map((item: any) => ({
        id: item.plans.systems.id,
        name: item.plans.systems.name,
        code: item.plans.systems.code,
        plan_name: item.plans.name
      })) || [];
    },
    enabled: !!companyId,
  });
};